import { styled } from '@mui/material';

export const CropAreaContainer = styled('div')(() => ({
  position: 'relative',
  width: '100%',
  height: '50vh',
}));
